module.exports = __webpack_public_path__ + "static/tail_analysis-5b778f69dd8e716bda624d00dbf4574b.png";